module.exports = __webpack_public_path__ + "static/media/washington-dc-74.a215731f.jpg";